/* global localStorage */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import withState from 'recompose/withState';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import { connect } from 'react-redux';
import isString from 'lodash.isstring';
import IconButton from '../IconButton';
import Close from '../Icons/Close';
import styles from './MaintenanceNotification.css';
import maintenanceIcon from '../../../../public/img/MaintenanceIcon.png';

const MaintenanceNotification = ({
  hideNotification,
  hidden,
  primaryColor,
  auth,
}) => {
  const savedMessage = useMemo(
    () => (isString(auth.bannerMessage) ? auth.bannerMessage : ''),
    [auth.bannerMessage],
  );

  if (hidden) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.text_container}>
        <div className={styles.content}>
          <img
            alt="Maintenance warning icon"
            src={maintenanceIcon}
            className={styles.warning_icon}
          />
          <p className={styles.warningMessage}>{savedMessage}</p>
        </div>
      </div>

      <IconButton
        className={styles.close}
        onClick={() => {
          hideNotification(true);
          hide();
        }}
        icon={Close}
        iconProps={{
          fill: primaryColor,
          size: 18,
        }}
      />
    </div>
  );
};

MaintenanceNotification.propTypes = {
  hideNotification: PropTypes.func,
  hidden: PropTypes.bool,
  primaryColor: PropTypes.string,
  auth: PropTypes.object,
};

const hide = () => {
  try {
    localStorage.setItem('maintenance-notification', process.env.MAINTENANCE);
  } catch (e) {
    // do nothing
  }
};

const initialValue = () => {
  try {
    const existing = localStorage.getItem('maintenance-notification');
    return process.env.MAINTENANCE === existing;
  } catch (e) {
    return false;
  }
};

export default compose(
  connect(
    ({ theme, auth }) => ({
      primaryColor: theme.primaryColor,
      auth,
    }),
    {},
  ),
  withState('hidden', 'hideNotification', initialValue()),
  lifecycle({
    componentWillMount() {},
    componentDidMount() {
      window.scrollTo(0, 0);
    },
  }),
)(MaintenanceNotification);



// WEBPACK FOOTER //
// ./src/client/Components/MaintenanceNotification/MaintenanceNotification.js